import axios from "../axios";

export default class SpecialCodeService {
  async getCitiesActives() {
    let res = await axios.get("City/actives");
    return res.data;
  }

  async getAccreditedsActives() {
    let res = await axios.get("Accrediteds/actives");
    return res.data;
  }

  async getCityByCodeCity(codeCity) {
    let res = await axios.get(
      "City/GetCityByCode?code_city_netsms=" + codeCity
    );
    return res.data;
  }

  async getCodeCityByName(nameCity) {
    let res = await axios.get("City/GetCodeCityByName?name_city=" + nameCity);
    return res.data;
  }

  async saveSpecialCode(data) {
    let res = await axios.post("Attendance/finish-attendance-dynamic", data);
    return res.data;
  }

  async saveTechnicianPhoneNumberAndAccredite(data) {
    let res = await axios.post("Technician", data);
    return res.data;
  }

  async getAllActions() {
    let res = await axios.get("/Report/getAllActions");
    return res.data;
  }

  async getAllStateEquipaments() {
    let res = await axios.get("/Report/getAllStateEquipaments");
    return res.data;
  }

  async getOptionList() {
    let res = await axios.get("/Attendance/get-service-option?type_attendance=2");
    return res.data;
  }

  async getTypeOsByServiceOption(serviceOption) {
    let res = await axios.get(`/TypeOs/serviceOptions?id_service_option=${serviceOption}`);
    return res.data;
  }

  async getInstallationImpedimentList(){
    let res = await axios.get("/Attendance/get-list-for-selection?impedimento_instalacao");
    return res.data;
  }

  async getWriteOffCodeByOption(serviceOption){
    let res = await axios.get(`/CodBaixa/getByServiceOption?id_service_option=${serviceOption}`);
    return res.data;
  }
}
